import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../components/CustomFormsComponents/CustomField';

const useDeregisterAvisoObraFieldsConfig = ({ t, formData, handleBlurValidation }: any) => {
    const [fieldsConfig, setFieldsConfig] = useState<FieldConfig[]>([]);

    useEffect(() => {
        const fieldsConfig: FieldConfig[] = [
            {
                type: 'text',
                label: t('avisoObraForms.deregister.inputs.observation') as string,
                name: 'observation',
                required: true,
                value: formData.observation,
                disabled: false,
                helperText: t('avisoObraForms.deregister.inputs.observation') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                validations: [{ name: 'required' }]
            }
        ];

        setFieldsConfig(fieldsConfig);
    }, [t, formData]);

    return {
        fieldsConfig
    };
};

export default useDeregisterAvisoObraFieldsConfig;
